import React, { useState, useEffect } from 'react';
import FadeInAnimation from "../Common/FadeInAnimation";
import { Player } from '@lottiefiles/react-lottie-player';
import Link from "next/link";
import { useTranslations } from '../../locales/useTranslations';
import { BiChevronRight, BiLogoWordpress } from "react-icons/bi";

const WebentwicklungEigenschaften = () => {
    const { t } = useTranslations();
    const [autoplay, setAutoplay] = useState(null);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        const checkIsMobile = () => {
            const width = window.innerWidth;
            const isMobile = width < 768;
            return isMobile;
        };

        setAutoplay(checkIsMobile());
        setIsReady(true);

        const handleResize = () => {
            setAutoplay(checkIsMobile());
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    if (!isReady) {
        return (
            <div className="features-card-section pt-70 pb-70 bg-f8fbfa">
                <div className="container">
                    <div className="row">
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="features-card-section pt-70 pb-70 bg-f8fbfa">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-sm-12">
                        <FadeInAnimation direction="up" delay={50}>
                            <div className="single-features-card tx-center">
                                <Player
                                    {...(autoplay && { autoplay: true })}
                                    loop
                                    hover
                                    src="/images/lottie/responsive.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('webDevelopment_features_responsive_title')}</h3>
                                <p>{t('webDevelopment_features_responsive_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-4 col-sm-12">
                        <FadeInAnimation direction="up" delay={100}>
                            <div className="single-features-card tx-center">
                                <Player
                                    {...(autoplay && { autoplay: true })}
                                    loop
                                    hover
                                    src="/images/lottie/target.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('webDevelopment_features_targeted_title')}</h3>
                                <p>{t('webDevelopment_features_targeted_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-4 col-sm-12">
                        <FadeInAnimation direction="up" delay={150}>
                            <div className="single-features-card tx-center">
                                <Player
                                    {...(autoplay && { autoplay: true })}
                                    loop
                                    hover
                                    src="/images/lottie/webdevelopment.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('webDevelopment_features_design_title')}</h3>
                                <p>{t('webDevelopment_features_design_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-sm-12">
                        <FadeInAnimation direction="up" delay={50}>
                            <div className="single-features-card tx-center">
                                <Player
                                    {...(autoplay && { autoplay: true })}
                                    hover
                                    loop
                                    src="/images/lottie/web-scaling.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('webDevelopment_features_scalability_title')}</h3>
                                <p>{t('webDevelopment_features_scalability_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-4 col-sm-12">
                        <FadeInAnimation direction="up" delay={100}>
                            <div className="single-features-card tx-center">
                                <Player
                                    {...(autoplay && { autoplay: true })}
                                    loop
                                    hover
                                    src="/images/lottie/web-performance.json"
                                    style={{ height: '300px' }}
                                    initialSegment={[51.5, 200]}
                                />
                                <h3>{t('webDevelopment_features_performance_title')}</h3>
                                <p>{t('webDevelopment_features_performance_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-4 col-sm-12">
                        <FadeInAnimation direction="up" delay={150}>
                            <div className="single-features-card tx-center">
                                <Player
                                    {...(autoplay && { autoplay: true, play: true })}
                                    loop
                                    hover
                                    src="/images/lottie/seo.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('webDevelopment_features_seo_title')}</h3>
                                <p>{t('webDevelopment_features_seo_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>
                </div>

                <h2 className="webdev-features__services-title">{t('webDevelopment_wordpressServices_title')}</h2>

                <div className="service-details-info">
                    <div className="col-sm-12">
                        <div className="single-info-box">
                            <Link href="/web-development/wordpress-entwicklung" className="read-more">
                                <div className="features-box">
                                    <div className="icon">
                                        <BiLogoWordpress />
                                    </div>
                                    <h3>{t('webDevelopment_wordpressServices_development_title')}</h3>
                                    <p>
                                        {t('webDevelopment_wordpressServices_development_description')}
                                    </p>
                                    <span className="features-box-action">{t('webDevelopment_wordpressServices_development_readMore')}
                                    <BiChevronRight />
                                    </span>
                                    <div className="back-icon">
                                        <BiLogoWordpress />
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>

                    <div className="col-sm-12">
                        <div className="single-info-box">
                            <Link href="/web-development/wordpress-betreuung" className="read-more">
                                <div className="features-box" >
                                    <div className="icon">
                                        <BiLogoWordpress />
                                    </div>
                                    <h3>{t('webDevelopment_wordpressServices_support_title')}</h3>
                                    <p>
                                        {t('webDevelopment_wordpressServices_support_description')}
                                    </p>
                                    <span className="features-box-action">{t('webDevelopment_wordpressServices_support_readMore')}
                                    <BiChevronRight />
                                    </span>
                                    <div className="back-icon">
                                        <BiLogoWordpress />
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WebentwicklungEigenschaften;
